"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileSpreadsheetSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="15" y="18" width="6" height="2"/><rect x="11" y="18" width="2" height="2"/><rect x="11" y="22" width="2" height="2"/><path d="M18,12a1,1,0,0,1-1-1V2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V12Zm5,12.5A1.5,1.5,0,0,1,21.5,26h-11A1.5,1.5,0,0,1,9,24.5v-9A1.5,1.5,0,0,1,10.5,14h11A1.5,1.5,0,0,1,23,15.5Z"/><rect x="15" y="22" width="6" height="2"/><path d="M26,8.59l-.29-.3-5-5L20.41,3A3.443,3.443,0,0,0,19,2.19V10h7.81A3.443,3.443,0,0,0,26,8.59Z"/>';
var FileSpreadsheetSVG = function FileSpreadsheetSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileSpreadsheetSVG = FileSpreadsheetSVG;
FileSpreadsheetSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileSpreadsheetSVG);
exports.default = _default;